import { Helmet } from "react-helmet-async"
import { Container } from "@sembark-travel/ui-base"
import { TripQuoteWhatsAppTemplates } from "../../../../../EmailPdfTemplates"

export default function OrganizationQuoteWhatsAppTemplatesPage() {
	return (
		<>
			<Helmet>
				<title>Quote WhatsApp Templates</title>
			</Helmet>
			<Container paddingY="4">
				<TripQuoteWhatsAppTemplates />
			</Container>
		</>
	)
}
